module.exports = __webpack_public_path__ + "img/DiscoveryAds.2c7b9789.svg";